var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCfNetworkElement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3170_64992)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3170_64992)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0.5C1.34315 0.5 0 1.84315 0 3.5V27.5C0 29.1569 1.34315 30.5 3 30.5H27C28.6569 30.5 30 29.1569 30 27.5V3.5C30 1.84315 28.6569 0.5 27 0.5H3Z",
    fill: "#F5F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0.5C1.34315 0.5 0 1.84315 0 3.5V27.5C0 29.1569 1.34315 30.5 3 30.5H27C28.6569 30.5 30 29.1569 30 27.5V3.5C30 1.84315 28.6569 0.5 27 0.5H3Z",
    fill: "url(#paint0_linear_3170_64992)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0.5C1.34315 0.5 0 1.84315 0 3.5V27.5C0 29.1569 1.34315 30.5 3 30.5H27C28.6569 30.5 30 29.1569 30 27.5V3.5C30 1.84315 28.6569 0.5 27 0.5H3Z",
    fill: "#5C7080"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3599 12.09C20.2099 10.96 20.8599 10.08 21.4599 9.22L20.4299 8.03C18.7099 8.91 16.3099 8.68 14.7999 7.5C13.2899 8.68 10.8899 8.91 9.16986 8.02L8.13986 9.22C8.74986 10.08 9.38986 10.96 9.23986 12.09C8.93986 14.38 6.78986 16.26 7.91986 18.77C8.36986 19.91 9.35986 20.67 10.6399 20.97C12.1999 21.33 14.1599 21.69 14.7999 23.5C15.4399 21.69 17.3999 21.34 18.9599 20.96C20.2399 20.66 21.2299 19.9 21.6799 18.76C22.7999 16.26 20.6499 14.38 20.3599 12.09Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3170_64992",
    x: 0,
    y: -0.5,
    width: 30,
    height: 31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0862745 0 0 0 0 0.101961 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3170_64992"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3170_64992",
    x1: 0,
    y1: 0.5,
    x2: 0,
    y2: 30.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3170_64992"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 30,
    height: 30,
    rx: 3,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCfNetworkElement);
export default __webpack_public_path__ + "static/media/CF_Network_Element.fcf84162aa8eb59c700e10424093f895.svg";
export { ForwardRef as ReactComponent };